import { type JSX } from 'react';
import { ThemeProvider } from '@doxyme/ui-foundation/theme';
import { IntlProvider } from '@doxyme/locale';
import { FullPageSpinner } from '../components/global/fullPageSpinner';

/**
 * Shown by React Router 7 while the lazy root layout chunk resolves on initial
 * hydration. Must not depend on `RootLayout` providers — wrap the minimum set
 * required by `FullPageSpinner` (`ThemeProvider`, `IntlProvider`).
 */
export const RouteHydrateFallback = (): JSX.Element => (
  <IntlProvider>
    <ThemeProvider themeName='light'>
      <FullPageSpinner />
    </ThemeProvider>
  </IntlProvider>
);
